export const sync = {
   uri: "/api/temp/v1/syncTemp/",
} as const;

export const set = {
   uri: "/api/temp/v1/setTemp/",
} as const;
export const get = {
   uri: "/api/temp/v1/getTemp/",
} as const;

export const orderClone = {
   uri: "/api/temp/v1/tempOrderClone/",
} as const;
